import ky from 'ky'

type FileDownloadProps = {
    fileUrl?: string
    filename?: string
}

/**
 * Chrome 65+ and Firefox only support same-origin download links.
 * So we fetch the file and convert it to blob and create a temp anchor tag
 * with the blog as href and the download attribute.
 * Then we programmatically click the anchor to download the file.
 */
const downloadFile = async ({fileUrl, filename = 'file'}: FileDownloadProps) => {
    if (fileUrl) {
        const fileBlob = await ky(fileUrl).blob()
        const file = window.URL.createObjectURL(fileBlob)
        const link = document.createElement('a')
        link.href = file
        link.setAttribute('download', filename)

        document.body.appendChild(link)

        link.click()
        link.parentNode?.removeChild(link)
        window.URL.revokeObjectURL(file)
    }
}

export default downloadFile
